module.exports = __webpack_public_path__ + "static/img/2.8efde49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/2.png
// module id = JhBa
// module chunks = 12